export enum LoadingActionType {
  SET_IS_LOADING = '@@loading/SET_IS_LOADING',
}
